import React from "react";

import { CardBlock, CardGridBlock as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";
import { Card } from "./Card";

import styles from "./index.module.scss";

const CardGrid = ({ value }: { value: CardBlock[] }) => (
    <ul role="list" className={styles.grid}>
        {value.map((card, index) => (
            <Card key={index} value={card} />
        ))}
    </ul>
);

const components = {
    rich_text_stream: RichTextStreamBlock,
    spacer: SpacerBlock,
    cards: CardGrid,
};

export const CardGridBlock = ({ value }: { value: Value }) => {
    if (!value.items) return null;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
